import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import React from 'react';

const createKeyframes = (theme) => ({
  '@keyframes blink': {
    '0%': {
      boxShadow: `0 0 5px ${theme.palette.primary.A500}`,
    },
    '50%': {
      backgroundColor: theme.palette.primary.A200,
      boxShadow: `0 0 20px ${theme.palette.primary.A800}`,
    },
    '100%': {
      boxShadow: `0 0 5px ${theme.palette.primary.main}`,
    },
  },
  '@keyframes blinkSoft': {
    '0%': {
      boxShadow: `0 0 3px ${theme.palette.primary.A500}`,
    },
    '50%': {
      backgroundColor: theme.palette.primary.A500,
      boxShadow: `0 0 12px ${theme.palette.primary.A500}`,
    },
    '100%': {
      boxShadow: `0 0 3px ${theme.palette.primary.A500}`,
    },
  }
});

export default function Blinker({
  CustomComponent,
  children,
  innerRef,
  isBlinking,
  softIntensity,
  ...props
}) {
  return (
    <CustomComponent
      ref={innerRef}
      {...props}
      sx={(theme) => ({
        animation: isBlinking ? 
          `${softIntensity ? 'blinkSoft' : 'blink'} ${softIntensity ? 1.5 : 2}s linear infinite` : 
          'none',
        '@keyframes blink': createKeyframes(theme)['@keyframes blink'],
        '@keyframes blinkSoft': createKeyframes(theme)['@keyframes blinkSoft'],
      })}
    >
      {children}
    </CustomComponent>
  );
}

Blinker.propTypes = {
  children: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  innerRef: PropTypes.any,
  // eslint-disable-next-line react/forbid-prop-types
  CustomComponent: PropTypes.object,
  isBlinking: PropTypes.bool.isRequired,
  softIntensity: PropTypes.bool,
};

Blinker.defaultProps = {
  innerRef: () => { },
  children: undefined,
  CustomComponent: IconButton,
  softIntensity: false,
};
